import { DrawCabinetInsideElement } from './DrawCabinetInsideElement';

export class DrawInsidePlateHolder extends DrawCabinetInsideElement {
    Number!: number;
}
